import Model from "./base/model";

class fatura extends Model{
  resourceName() {
    return "faturas";
  }

  fields() {
    return {
      path: "",
      name: "",
      expire_date: "",
      type: "",
      emission_date: "",
      value: "",
      number: "",
      is_structure_ok: "",
      documents_issue: "",
      cnpj_sacado: "",
      approved: "",
      requested_change: "",
      quotation_id: "",
      visible: "",
    }
  }

  async find(id) {
    return this.request(
      this.resourceName() + "/" + id,
      "GET",
      {},
      {}
    );
  }
}

export default new fatura();
